export default __webpack_public_path__ + "static/chronological-age-calculator-pearson-392f0c3b61c8710b563635bf46030a0d.png";